import { initializeApp } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import configData from "../config.json";

// Firebase web config (public values) lives in config.json under `firebase`, swapped
// per environment by CI like the other config keys. See FIRESTORE-SETUP.md.
const app = initializeApp(configData.firebase);

export const auth = getAuth(app);
export const db = getFirestore(app);

let inFlight = null;

/**
 * Sign in to Firebase with an account-scoped custom token minted by the API
 * (operator login or the public /back-display endpoint).
 *
 * Firebase persists the session (and auto-refreshes the ID token) across reloads, so
 * this is effectively a no-op refresh when a session already exists. De-dupes concurrent
 * calls. Non-fatal: logs and resolves on failure so the rest of the app is unaffected
 * (Firestore reads don't begin until M3).
 */
export function signInToFirebase(customToken) {
  if (!customToken) return Promise.resolve(null);
  if (inFlight) return inFlight;

  inFlight = signInWithCustomToken(auth, customToken)
    .catch((err) => {
      console.error("Firebase sign-in failed:", err);
      return null;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}

export default app;
